var map = {
	"./header-menu-box01-blood.svg": 73120,
	"./header-menu-box02-blood.svg": 29327,
	"./header-menu-box03-blood.svg": 94954,
	"./header-menu-box04-blood.svg": 69937,
	"./header-menu-box05-blood.svg": 49004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16273;